import { useEffect, useRef } from 'react';

export const uploadTemplateCsvData =
  btoa(`*passenger_first_name,*passenger_last_name,*payer,*transport_type,*service_type,*will_call,*trip_date,*input_price,*pickup_address,*pickup_time,*dropoff_address,id,passenger_phone_number,passenger_email,passenger_dob,passenger_gender,passenger_weight,passenger_is_bariatric,passenger_notes,attendants_needed,additional_passengers,oxygen_required,oxygen_liters_per_min,requested_by_name,requested_by_phone_number,dispatcher_notes,pickup_address_details,pickup_stairs,pickup_stair_equipment,pickup_driver_notes,pickup_contact_name,pickup_contact_phone_number,load_time,dropoff_address_details,appointment_time,dropoff_stairs,dropoff_stair_equipment,dropoff_driver_notes,dropoff_contact_name,dropoff_contact_phone_number,unload_time,must_provide_wheelchair,has_infectious_disease,tag_list
Violet,Sabrewing,facility pay,wheelchair,door-to-door,TRUE,01/01/2025,$50.50 ,"800 Boylston St, Boston, MA 02199",13:00,"100 Winsor Dam Rd, Belchertown, MA 01007",,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,TRUE,FALSE,test
Ruby-throated,Hummingbird,self-pay,ambulatory,curb-to-curb,FALSE,01/01/2025,$100.20 ,"26 Oxford St, Cambridge, MA 02138",11:00,"1 Patriot Pl, Foxborough, MA 02035",2024-01-01-4,857-555-5512,test+ruby@bambi.health,01/01/1980,female,1,FALSE,"the most common hummingbird in eastern North America, having population estimates of about 35 million in 2021",1,1,TRUE,1.500,Dr. Doolittle,857-555-5511,wants a very gentle ride,Harvard Museum of Natural History,8,ramp,oxford street entrance,Prof X,857-555-5522,5,Gillette Stadium,12:00,300,ramp,go pats!,the coach,857-555-5533,5,FALSE,FALSE,
Garden,Emerald,selfpay,stretcher,door-through-door,FALSE,01/01/2025,$300.00 ,"1 Franklin Park Rd, Boston, MA 02121",14:44,"291 US-6, South Wellfleet, MA 02663",2024-01-01-5,,test+emerald@bambi.health,01/01/1980,male,,,"forages for nectar by visiting a circuit of flowering trees, shrubs, and other plants",2,0,FALSE,,,,,Zoo,,,gate code 1234,,,,,,,,,,,25,FALSE,FALSE,"Priority,test"`);

export function UploadDetailsSampleDownloadFile() {
  const linkRef = useRef<HTMLAnchorElement>(null);

  useEffect(() => {
    if (!linkRef.current) {
      return;
    }

    const data = window.atob(uploadTemplateCsvData);
    const blob = new Blob([data], { type: 'text/csv' });

    linkRef.current.href = window.URL.createObjectURL(blob);
    linkRef.current.download = 'BambiUploadSample.csv';
  }, []);

  return (
    <a
      href="#download-csv"
      ref={linkRef}
      className="text-sm text-mint underline"
    >
      Sample Template
    </a>
  );
}
